import { useTranslation } from "react-i18next";

const TableDataText = ({ data }) => {
  const { t } = useTranslation();
  return <td data-item={data.toUpperCase()}>{t(data.toUpperCase())}</td>;
};

export default TableDataText;
